import { Link } from "react-router-dom"
import { forwardRef, HTMLAttributes, memo } from "react"
import cn from "classnames"

import { Icon } from "components"
import { Button, Img, Text } from "ui-kit/components-branded/index"
import { isClientAccountPage, isPsyAccountPage } from "app/AppRouter/utils"

interface LeaveCallButtonProps extends HTMLAttributes<HTMLDivElement> {
    className?: string
}

export const LeaveCallButton = memo(
    forwardRef<HTMLButtonElement, LeaveCallButtonProps>(({ className }, ref) => (
        <button
            ref={ref}
            className={cn("video-controls__button is-rounded is-red", className)}
            type="button"
        >
            <Icon className="video-controls__icon" type="end-call" size={32} />
        </button>
    ))
)

LeaveCallButton.displayName = "LeaveCallButton"

interface Props extends HTMLAttributes<HTMLDivElement> {
    hangUpLink?: string
    lobbyLink?: string
}

export const LeaveCallConfirmationPopover = forwardRef<HTMLDivElement, Props>(
    ({ hangUpLink, lobbyLink, ...props }, ref) => {
        if (!hangUpLink || !lobbyLink) return null

        return (
            <div className="video-controls__overlay video-controls__content" {...props} ref={ref}>
                <Link to={hangUpLink} className="is-block text-decoration-none">
                    <Button isFullwidth color="danger">
                        {isPsyAccountPage() && <>Завершить сессию для&nbsp;всех</>}
                        {isClientAccountPage() && <>Завершить звонок</>}
                    </Button>
                </Link>

                {isPsyAccountPage() && (
                    <>
                        <Text className="is-block mb-3 mt-2">
                            <Img src="attention.png" className="video-controls__overlay-icon" />
                            После завершения сесии вернуться в&nbsp;звонок будет нельзя.
                        </Text>

                        <Link to={lobbyLink} className="is-block text-decoration-none">
                            <Button isFullwidth className="has-text-white">
                                Перезайти в звонок
                            </Button>
                        </Link>
                    </>
                )}
            </div>
        )
    }
)

LeaveCallConfirmationPopover.displayName = "LeaveCallConfirmationPopover"
